import { useQuery } from "@apollo/client";
import { Box, Button, Card, Flex, Heading, Image, Text } from "rebass/styled-components";
import styled from "styled-components";
import RecipeAllergenIndicator from "../../../../components/recipeIndicator/RecipeAllergenIndicator";
import { GET_AIP_RECIPE } from "../../../../graphql/queries";
import { IGetAipRecipeFromWebInput, IGetAipRecipeFromWebOutput, IThumbnailAipRecipeOutput } from "../../../../graphql/types/queries/recipes"

const Container = styled(Flex)`
  /* padding-left: 20px;
  padding-right: 20px;
  padding-top: 24px;
  margin-bottom: 64px; */
  @media screen and (max-width: 480px) {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
  }
`;

const Img = styled(Image)`
  transition: 0.3s all ease-in-out;
  object-fit: cover;
  &:hover {
    transform: scale(1.1);
  }
`;

const AvatarImg = styled(Flex)`
  background: #ffe3d8;
  border-radius: 50%;
  border: 0px solid #ccc;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  min-width: 64px;
  & > img {
    width: 64px;
  }
`;

const ArticleCardContainer = styled(Flex)`
  transition: 0.3s all ease-in-out;
  & > * {
    transition: 0.3s all ease-in-out;
  }
  &:hover > * {
    opacity: 0.5;
  }
  &:hover > :hover {
    opacity: 1;
  }
`;

const CategoryTag = styled(Text)`
  transition: 0.3s all ease-in-out;
  text-decoration: underline, 
  cursor: pointer,
 font-weight: 300;
 color: #F8A294;
`;

const BoxRight = styled(Box)`
  width: 274px;
  padding-left: 20px;

  @media screen and (max-width: 1300px) {
    display: none;
  }
`;

const BoxRightMobile = styled(Flex)`
  flex-direction: column;
  justify-content: flex-end;
  @media screen and (min-width: 1300px) {
    display: none;
  }
`;
const CardWrap = styled(Card)`
  border-radius: 10px;
  /* margin-right: 20px; */
  flex: initial;
  @media screen and (max-width: 480px) {
    width: 100%;
    max-width: 100vw;
  }
`;

const Category = ({ title, isSelected }: { title: string, isSelected?: boolean }) => {
  if (!isSelected) return null
  return (
    <CategoryTag mb={2} style={{ fontWeight: isSelected ? 600 : '' }}>
      {title}
    </CategoryTag>
  );
};
const ViewRecipe = ({ thumbnail, selectedRecipes, onSelect, onCancel, canSelect = true }: { canSelect?: boolean, thumbnail: IThumbnailAipRecipeOutput, selectedRecipes: Array<IThumbnailAipRecipeOutput>, onSelect: () => void, onCancel: () => void }) => {
  const { data, loading } = useQuery<IGetAipRecipeFromWebOutput, IGetAipRecipeFromWebInput>(GET_AIP_RECIPE, {
    variables: {
      id: thumbnail.id
    }
  })
  return (
    <Flex flexDirection={'column'} style={{ maxHeight: '100%' }}>

      <Container flexDirection="row" id="cont" overflowY={'auto'}>
        <Box flexDirection={'column'} maxWidth='700px' style={{ paddingBottom: '24px' }}>
          <CardWrap>
            <Box style={{ position: 'relative', overflow: 'hidden', width: '100%', height: '290px' }}>
              <Img height={290} width={'100%'} src={thumbnail.image} />
            </Box>
            <Flex flexDirection={'column'} p="44px">
              <Heading mb="36px" textAlign={'center'}>
                {thumbnail.name}
              </Heading>
              {!loading &&
                !!data &&
                data.getAipRecipeFromWeb && (
                  <Flex flexDirection={'column'}>
                    <Flex mb="24px">
                      <Flex flexDirection={'column'} style={{ flex: 'initial' }} mr={4}>
                        <Text fontWeight={600} fontSize="20px">
                          {data.getAipRecipeFromWeb.serving}
                        </Text>
                        <Text fontWeight={300} fontSize='14px'>Servings</Text>
                      </Flex>
                      <Flex flexDirection={'column'} style={{ flex: 'initial' }} mr={4}>
                        <Flex alignItems={'flex-end'}>
                          <Text fontWeight={600} fontSize="20px">
                            {data.getAipRecipeFromWeb.totalTimeMinutes}
                          </Text>
                          <Text fontWeight={300} fontSize="16px">
                            &nbsp;min
                          </Text>
                        </Flex>
                        <Text fontWeight={300} fontSize='14px'>Total Time</Text>
                      </Flex>
                      <Flex flexDirection={'column'} style={{ flex: 'initial' }} mr={4}>
                        <Flex alignItems={'flex-end'}>
                          <Text fontWeight={600} fontSize="20px">
                            {data.getAipRecipeFromWeb.activeTimeMinutes}
                          </Text>
                          <Text fontWeight={300} fontSize="16px">
                            &nbsp;min
                          </Text>
                        </Flex>
                        <Text fontWeight={300} fontSize='14px'>Active Time</Text>
                      </Flex>
                    </Flex>

                    <Flex flexDirection={'row'} style={{ overflowX: 'auto', paddingBottom: '24px', marginLeft: '-44px', marginRight: '-44px', paddingLeft: '44px', paddingRight: '44px' }}>
                      {data.getAipRecipeFromWeb.alcoholFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Alcohol-Free'} />}
                      {data.getAipRecipeFromWeb.balanced && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Balanced'} />}
                      {data.getAipRecipeFromWeb.caffeineFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Coffee-Free'} />}
                      {data.getAipRecipeFromWeb.dairyFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Dairy-Free'} />}
                      {data.getAipRecipeFromWeb.eggFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Egg-Free'} />}
                      {data.getAipRecipeFromWeb.fatFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Low-Fat'} />}
                      {data.getAipRecipeFromWeb.fishFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Fish-Free'} />}
                      {data.getAipRecipeFromWeb.glutenFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Gluten-Free'} />}
                      {data.getAipRecipeFromWeb.highFiber && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'High-Fiber'} />}
                      {data.getAipRecipeFromWeb.highProtein && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'High-Protein'} />}
                      {data.getAipRecipeFromWeb.lowCarb && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Low-Carb'} />}
                      {data.getAipRecipeFromWeb.lowFat && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Low-Fat'} />}
                      {data.getAipRecipeFromWeb.lowSodium && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Low-Sodium'} />}
                      {data.getAipRecipeFromWeb.lowSugar && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Low-Sugar'} />}
                      {data.getAipRecipeFromWeb.nightshadeFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Nightshade'} />}
                      {data.getAipRecipeFromWeb.paleo && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Paleo'} />}
                      {data.getAipRecipeFromWeb.peanutFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Peanut-Free'} />}
                      {data.getAipRecipeFromWeb.shellfishFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Shellfish-Free'} />}
                      {data.getAipRecipeFromWeb.soyFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Soy-Free'} />}
                      {data.getAipRecipeFromWeb.treeNutFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Tree-Nut-Free'} />}
                      {data.getAipRecipeFromWeb.vegan && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Vegan'} />}
                      {data.getAipRecipeFromWeb.vegetarian && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Vegetarian'} />}
                      {data.getAipRecipeFromWeb.wheatFree && <RecipeAllergenIndicator containerStyle={{ marginRight: 18 }} allergen={'Wheat-Free'} />}
                    </Flex>

                    <Text fontSize={'16px'} fontWeight={600} mb={3} mt={4}>
                      Ingredients
                    </Text>
                    <Flex style={{ whiteSpace: 'pre-wrap', fontSize: '14px' }}>{((data || {}).getAipRecipeFromWeb || {}).ingredients}</Flex>
                    <Text fontSize={'16px'} fontWeight={600} mt={4} mb={3}>
                      Instructions
                    </Text>
                    <Flex style={{ whiteSpace: 'pre-wrap', fontSize: '14px' }}>{((data || {}).getAipRecipeFromWeb || {}).instructions}</Flex>
                    {!!((data || {}).getAipRecipeFromWeb || {}).options && (
                      <>
                        <Text fontSize={'16px'} fontWeight={600} mt={4} mb={3}>
                          Options
                        </Text>
                        <Flex style={{ whiteSpace: 'pre-wrap', fontSize: '14px' }}>{((data || {}).getAipRecipeFromWeb || {}).options}</Flex>
                      </>
                    )}
                  </Flex>
                )}
            </Flex>
          </CardWrap>
          <Flex flexDirection={'column'} style={{ padding: '0 24px 24px 24px', marginBottom: '24px' }}>
            <Text fontSize={'16px'} fontWeight={600} mb={3} mt={4}>
              Recipe contributed by
            </Text>

            <Flex alignItems={'center'}>
              <AvatarImg style={{ alignSelf: 'center', marginRight: '6px' }}>
                <img alt="" src={((data || {}).getAipRecipeFromWeb || {}).authorImage} />
              </AvatarImg>
              <Text fontSize={'16px'} fontWeight={500}>
                {((data || {}).getAipRecipeFromWeb || {}).author}
              </Text>
            </Flex>
            <Text fontWeight={300} mt={4} mb={4} style={{ wordBreak: 'break-word', fontSize: '14px' }}>
              {((data || {}).getAipRecipeFromWeb || {}).authorBio}
            </Text>

            {!!((data || {}).getAipRecipeFromWeb || {}).authorWebsite && (
              <Flex alignItems={'center'} style={{ cursor: 'pointer' }} mb={3} onClick={() => window.open(((data || {}).getAipRecipeFromWeb || {}).authorWebsite, '_blank')}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.16659 12.8335C1.5145 13.1819 1.92782 13.4582 2.38281 13.6463C2.83779 13.8345 3.32548 13.9309 3.81784 13.93C4.31031 13.9309 4.79811 13.8345 5.25321 13.6463C5.70832 13.4581 6.12178 13.1819 6.46984 12.8335L8.59084 10.7118L7.53034 9.65128L5.40934 11.773C4.9867 12.1938 4.4146 12.43 3.81822 12.43C3.22184 12.43 2.64974 12.1938 2.22709 11.773C1.80597 11.3506 1.5695 10.7784 1.5695 10.1819C1.5695 9.58541 1.80597 9.01324 2.22709 8.59078L4.34884 6.46978L3.28834 5.40928L1.16659 7.53028C0.464448 8.23412 0.0701294 9.18772 0.0701294 10.1819C0.0701294 11.1761 0.464448 12.1297 1.16659 12.8335ZM12.8336 6.46978C13.5354 5.76575 13.9294 4.81222 13.9294 3.81816C13.9294 2.82409 13.5354 1.87057 12.8336 1.16653C12.1298 0.464387 11.1762 0.0700684 10.182 0.0700684C9.18778 0.0700684 8.23419 0.464387 7.53034 1.16653L5.40934 3.28828L6.46984 4.34878L8.59084 2.22703C9.01349 1.80628 9.58559 1.57005 10.182 1.57005C10.7783 1.57005 11.3504 1.80628 11.7731 2.22703C12.1942 2.64949 12.4307 3.22166 12.4307 3.81816C12.4307 4.41466 12.1942 4.98683 11.7731 5.40928L9.65134 7.53028L10.7118 8.59078L12.8336 6.46978Z"
                    fill="#354E79"
                  />
                  <path d="M4.34807 10.7125L3.28682 9.65201L9.65207 3.28751L10.7126 4.34876L4.34807 10.7125Z" fill="#354E79" />
                </svg>
                <Text fontWeight={'500'} ml={3} mr={3} fontSize='14px'>
                  Visit website
                </Text>
                <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.85208 6.84526L1.69211 12.8568C1.49489 13.0477 1.17598 13.0477 0.978757 12.8568L0.147915 12.0526C-0.0493051 11.8617 -0.0493051 11.553 0.147915 11.3621L5.12038 6.5L0.147915 1.63795C-0.0493051 1.44704 -0.0493051 1.13834 0.147915 0.94743L0.978757 0.143181C1.17598 -0.0477266 1.49489 -0.0477266 1.69211 0.143181L7.85208 6.15474C8.0493 6.34565 8.0493 6.65435 7.85208 6.84526Z"
                    fill="#354E79"
                  />
                </svg>
              </Flex>
            )}

            {!!((data || {}).getAipRecipeFromWeb || {}).instagramLink && (
              <Flex alignItems={'center'} style={{ cursor: 'pointer' }} mb={3} onClick={() => window.open(((data || {}).getAipRecipeFromWeb || {}).instagramLink, '_blank')}>
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.49771 4.13868C6.08425 4.13868 4.13648 6.08649 4.13648 8.5C4.13648 10.9135 6.08425 12.8613 8.49771 12.8613C10.9112 12.8613 12.859 10.9135 12.859 8.5C12.859 6.08649 10.9112 4.13868 8.49771 4.13868ZM8.49771 11.3345C6.93694 11.3345 5.66323 10.0608 5.66323 8.5C5.66323 6.9392 6.93694 5.66546 8.49771 5.66546C10.0585 5.66546 11.3322 6.9392 11.3322 8.5C11.3322 10.0608 10.0585 11.3345 8.49771 11.3345ZM13.0376 2.94362C12.4741 2.94362 12.019 3.39868 12.019 3.96218C12.019 4.52569 12.4741 4.98075 13.0376 4.98075C13.6011 4.98075 14.0561 4.52782 14.0561 3.96218C14.0563 3.82838 14.0301 3.69585 13.9789 3.5722C13.9278 3.44854 13.8528 3.33619 13.7582 3.24158C13.6636 3.14696 13.5512 3.07194 13.4276 3.02081C13.3039 2.96968 13.1714 2.94345 13.0376 2.94362ZM16.9991 8.5C16.9991 7.32621 17.0097 6.16305 16.9438 4.99138C16.8778 3.63046 16.5674 2.42264 15.5722 1.42747C14.575 0.430173 13.3693 0.121839 12.0084 0.0559198C10.8346 -0.00999972 9.67149 0.000632496 8.49984 0.000632496C7.32607 0.000632496 6.16293 -0.00999972 4.99129 0.0559198C3.63039 0.121839 2.4226 0.432299 1.42745 1.42747C0.430165 2.42477 0.121837 3.63046 0.0559188 4.99138C-0.00999953 6.16517 0.000632484 7.32833 0.000632484 8.5C0.000632484 9.67167 -0.00999953 10.837 0.0559188 12.0086C0.121837 13.3695 0.432291 14.5774 1.42745 15.5725C2.42473 16.5698 3.63039 16.8782 4.99129 16.9441C6.16506 17.01 7.3282 16.9994 8.49984 16.9994C9.67361 16.9994 10.8368 17.01 12.0084 16.9441C13.3693 16.8782 14.5771 16.5677 15.5722 15.5725C16.5695 14.5752 16.8778 13.3695 16.9438 12.0086C17.0118 10.837 16.9991 9.67379 16.9991 8.5ZM15.1278 13.5141C14.9726 13.9011 14.7855 14.1903 14.4857 14.488C14.1858 14.7879 13.8988 14.975 13.5118 15.1302C12.3933 15.5747 9.7374 15.4747 8.49771 15.4747C7.25803 15.4747 4.60003 15.5747 3.48154 15.1324C3.09454 14.9771 2.80535 14.79 2.50765 14.4902C2.20783 14.1903 2.02071 13.9033 1.86548 13.5163C1.42319 12.3956 1.52313 9.73971 1.52313 8.5C1.52313 7.26029 1.42319 4.60224 1.86548 3.48374C2.02071 3.09672 2.20783 2.80753 2.50765 2.50983C2.80748 2.21213 3.09454 2.02287 3.48154 1.86764C4.60003 1.42535 7.25803 1.52529 8.49771 1.52529C9.7374 1.52529 12.3954 1.42535 13.5139 1.86764C13.9009 2.02287 14.1901 2.21 14.4878 2.50983C14.7876 2.80966 14.9747 3.09672 15.1299 3.48374C15.5722 4.60224 15.4723 7.26029 15.4723 8.5C15.4723 9.73971 15.5722 12.3956 15.1278 13.5141Z"
                    fill="#354E79"
                  />
                </svg>

                <Text fontWeight={'500'} ml={3} mr={3} fontSize='14px'>
                  Visit Instagram
                </Text>
                <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.85208 6.84526L1.69211 12.8568C1.49489 13.0477 1.17598 13.0477 0.978757 12.8568L0.147915 12.0526C-0.0493051 11.8617 -0.0493051 11.553 0.147915 11.3621L5.12038 6.5L0.147915 1.63795C-0.0493051 1.44704 -0.0493051 1.13834 0.147915 0.94743L0.978757 0.143181C1.17598 -0.0477266 1.49489 -0.0477266 1.69211 0.143181L7.85208 6.15474C8.0493 6.34565 8.0493 6.65435 7.85208 6.84526Z"
                    fill="#354E79"
                  />
                </svg>
              </Flex>
            )}
            <Text fontSize={'18px'} fontWeight={600} mt={2} mb={3}>
              Categories
            </Text>

            <Category title="Dairy Free" isSelected={((data || {}).getAipRecipeFromWeb || {}).dairyFree} />

            <Category title="Gluten Free" isSelected={((data || {}).getAipRecipeFromWeb || {}).glutenFree} />

            <Category title="Sugar Free" isSelected={((data || {}).getAipRecipeFromWeb || {}).lowSugar} />

            <Category title="Egg Free" isSelected={((data || {}).getAipRecipeFromWeb || {}).eggFree} />

            <Category title="Peanut Free" isSelected={((data || {}).getAipRecipeFromWeb || {}).peanutFree} />

            <Category title="Tree-Nut Free" isSelected={((data || {}).getAipRecipeFromWeb || {}).treeNutFree} />

            <Category title="Soy Free" isSelected={((data || {}).getAipRecipeFromWeb || {}).soyFree} />

            <Category title="Nightshade Free" isSelected={((data || {}).getAipRecipeFromWeb || {}).nightshadeFree} />
          </Flex>
        </Box>
      </Container>
      <Flex justifyContent={'center'} padding='8px'>
        {!!canSelect ?
          <>
            <Button flex='initial' variant={'primary'} mr={2} onClick={onSelect}>{
              selectedRecipes.findIndex(x => x.id === thumbnail.id) < 0 ? 'Select' : 'Deselect'
            }</Button>
            <Button flex='initial' style={{ width: 'auto' }} variant={'outline'} ml={2} onClick={onCancel}>Cancel</Button>
          </> : (
            <Button flex='initial' style={{ width: 'auto' }} variant={'primary'} ml={2} onClick={onCancel}>Close</Button>
          )}
      </Flex>
    </Flex>
  );
}

export default ViewRecipe